module.exports = __webpack_public_path__ + "static/media/YM58_2.b7df3cf6.jpg";